import pro from '../../../assets/images/ico/pro.svg'
import arcade from '../../../assets/images/ico/arcade.svg'
import advance from '../../../assets/images/ico/advance.svg'

export const planList = [
  {
    id: 1,
    price: 9,
    uriIcon: arcade,
    title: 'Arcade',
    freeMonthPerYear: 2,
    priceFormat: '$9/mo'
  },{
    id: 2,
    price: 12,
    uriIcon: advance,
    title: 'Advanced',
    freeMonthPerYear: 2,
    priceFormat: '$12/mo'
  },{
    id: 3,
    price: 15,
    uriIcon: pro,
    title: 'Pro',
    freeMonthPerYear: 2,
    priceFormat: '$15/mo',
  }
]